import dayjs from './dayjs'

// Relative-time phrasing for activity timestamps. Recency is bucketed coarsely
// (today/yesterday) to avoid noise like "8 minutes ago"; dayjs handles the rest.
//
// `now` is deliberately required. The 24h/48h steps are hard, so a caller that
// reads the clock itself lands on a different label on the server than in the
// browser whenever the two disagree — the ENG-1246 hydration mismatch.
export function formatRelativeTime(date: Date, now: Date): string {
  const hoursAgo = dayjs(now).diff(date, 'hour')

  if (hoursAgo < 24) return 'today'
  if (hoursAgo < 48) return 'yesterday'

  return dayjs(date).from(dayjs(now))
}
